import { render, staticRenderFns } from "./trainingCourseManagement.vue?vue&type=template&id=a6861018&scoped=true&"
import script from "./trainingCourseManagement.vue?vue&type=script&lang=js&"
export * from "./trainingCourseManagement.vue?vue&type=script&lang=js&"
import style0 from "./trainingCourseManagement.vue?vue&type=style&index=0&id=a6861018&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6861018",
  null
  
)

export default component.exports